import { Box } from "@outschool/backpack";
import React from "react";

export default function HeadingMarker() {
  return (
    <Box
      sx={{
        height: 4,
        width: 32,
        backgroundColor: "warning.500",
        marginBottom: 10
      }}
    />
  );
}
